import React, { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { navigation, topBarLinks } from "../data/mock";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <header className="bg-white border-b border-gray-200 sticky top-0 z-40">
      <div className="max-w-[1400px] mx-auto px-6 py-4 flex items-center justify-between">
        {/* Logo */}
        <Link to="/" className="flex items-center gap-2" data-testid="header-logo-link">
          <span className="font-black text-xl tracking-tight text-black">FICHET</span>
          <div className="w-9 h-9 bg-[#C9A227] flex items-center justify-center">
            <span className="font-black text-lg text-black">S</span>
          </div>
          <span className="font-semibold text-xs text-gray-600 tracking-[0.2em] uppercase hidden sm:inline">Serrurerie</span>
        </Link>

        {/* Desktop Navigation */}
        <nav className="hidden lg:flex items-center gap-7">
          {navigation.slice(0, 6).map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) =>
                `text-sm font-medium tracking-tight relative py-2 transition-colors ${
                  isActive
                    ? "text-black after:absolute after:bottom-0 after:left-0 after:right-0 after:h-0.5 after:bg-[#C9A227]"
                    : "text-gray-700 hover:text-black"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        {/* Mobile menu button */}
        <button
          onClick={() => setIsOpen(!isOpen)}
          className="lg:hidden text-gray-700"
          aria-label="Menu"
          data-testid="mobile-menu-button"
        >
          {isOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {/* Mobile menu */}
      {isOpen && (
        <div className="lg:hidden bg-white border-t border-gray-200" data-testid="mobile-menu">
          <nav className="px-6 py-4 flex flex-col gap-3">
            {navigation.map((item) => (
              <NavLink
                key={item.path}
                to={item.path}
                onClick={() => setIsOpen(false)}
                className={({ isActive }) =>
                  `text-sm font-medium py-2 border-b border-gray-100 ${
                    isActive ? "text-black" : "text-gray-700"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
            {topBarLinks.map((item) => (
              <NavLink
                key={`top-${item.label}`}
                to={item.path}
                onClick={() => setIsOpen(false)}
                data-testid={`mobile-topbar-link-${item.path.replace("/", "")}`}
                className="text-sm font-bold py-2 border-b border-gray-100 text-[#8C6F14]"
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;
